module.exports = __webpack_public_path__ + "img/daftar-survey.d8831402.svg";